var render, staticRenderFns
import script from "./BarChartv2.vue?vue&type=script&lang=js"
export * from "./BarChartv2.vue?vue&type=script&lang=js"
import style0 from "./BarChartv2.vue?vue&type=style&index=0&id=70bd51a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bd51a2",
  null
  
)

export default component.exports